import { useTranslation } from 'react-i18next'

import { LinkSimpleIcon } from '@phosphor-icons/react'

import { ColorPicker, Divider, InputWithLabel, Text, UploadImage } from '@reveni-io/reveni-ui'

import { appearanceColorFields } from './constants'
import * as Styles from './styles'

const AppearanceTab = ({
  colors,
  onColorChange,
  footerImage,
  onFooterImageChange,
  footerImageLink,
  onFooterImageLinkChange,
  disabled,
}) => {
  const { t } = useTranslation()

  return (
    <>
      <Text type="bodyMRegular">{t('Define los estilos de color básicos usados en las notificaciones por email')}</Text>
      <Styles.Container>
        <Styles.ColorsContainer>
          {appearanceColorFields.map((field, index) => (
            <>
              <div key={field.key}>
                <ColorPicker
                  label={<Text type="bodyMBold">{t(field.label)}</Text>}
                  value={colors[field.key]}
                  defaultColor={colors[field.key]}
                  onChange={color => onColorChange(field.key, color)}
                  disabled={disabled}
                />
              </div>
              {index < appearanceColorFields.length - 1 && <Divider />}
            </>
          ))}
        </Styles.ColorsContainer>
        <Divider />
        <Styles.FooterImageContainer>
          <UploadImage
            label={<Text type="bodyMBold">{t('Banner de promoción')}</Text>}
            recommendation={t('Max 300KB. Recomendado 600x300px.')}
            maxSize={300}
            accept="image/png, image/jpeg, image/jpg, image/webp"
            onChange={onFooterImageChange}
            value={footerImage}
            defaultImage={footerImage}
            disabled={disabled}
          />
          <InputWithLabel
            placeholder={t('Link de la imagen del footer')}
            helperText={t('Añade el link al que dirigirá la imagen en el footer de los emails')}
            fullWidth
            startAdornment={<LinkSimpleIcon size={16} />}
            value={footerImageLink}
            onChange={onFooterImageLinkChange}
            disabled={disabled}
          />
        </Styles.FooterImageContainer>
      </Styles.Container>
    </>
  )
}

export default AppearanceTab
